import { useResidentContext } from "app/features/residents/provider/ResidentProvider";
import { FormEnums } from "app/services/api/types/forms/enums/FormEnums";
import { AssessmentReportFillTemplate } from "app/features/reporting/templates/AssessmentReportFillTemplate";

export function AddBradenScaleReport() {
  const { resident } = useResidentContext();

  const backPath = resident?.id
    ? `/residents/${resident.id}/braden-scale`
    : undefined;

  return (
    <AssessmentReportFillTemplate
      tag={FormEnums.BRADEN_SCALE}
      backPath={backPath}
    />
  );
}
